module.exports = __webpack_public_path__ + "img/644be05.png";